import React from 'react';
import { Route, Switch } from 'react-router-dom';

import List from './FacilityVerifications/List';
import Detail from './FacilityVerifications/Detail';

function FacilityVerifications() {
  return (
    <Switch>
      <Route exact path="/facility-verifications" component={List} />
      <Route path="/facility-verifications/:id" component={Detail} />
    </Switch>
  );
}

export default FacilityVerifications;
